import { render } from "./V2RequestProcessor.vue?vue&type=template&id=0712c420&scoped=true"
import script from "./V2RequestProcessor.vue?vue&type=script&lang=js"
export * from "./V2RequestProcessor.vue?vue&type=script&lang=js"

import "./V2RequestProcessor.vue?vue&type=style&index=0&id=0712c420&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0712c420"]])

export default __exports__